import { Logo } from './Brand.js';

/**
 * Story #91 — the FloorPoll mark, on a surface a customer's audience sees.
 *
 * Rendered only when the server says so: `PublicQuizState.vendorMark` is
 * derived from the entitlement stamped on the quiz item at presentation start,
 * so nothing a phone can claim — a query parameter, a self-declared `view` —
 * turns it off. This component is the drawing, never the decision.
 *
 * A lockup rather than a bare mark. The customer's own logo already sits at the
 * top of both surfaces, so a lone tile in a corner would read as a second logo
 * of theirs; the words are what make it a vendor's credit.
 *
 * Deliberately not a link. A taker is mid-vote on a phone, and the one thing
 * this must never do is offer to navigate away from the poll. The join URL on
 * the projector is already the route to floorpoll.app for anyone curious, and
 * it stays there on every plan.
 */
export function VendorMark() {
  return (
    <p className="vendor-mark">
      {/* The spaces are explicit and they are not decoration: without them
          this line reads out as "Powered byFloorPoll". A whitespace-only text
          node directly inside a flex container is not rendered, so they cost
          the layout nothing — the gap between the parts is the flex gap. */}
      <span className="vendor-mark-lead">Powered by</span>{' '}
      {/* The tile is aria-hidden inside Brand, so the accessible name of this
          line is exactly the sentence it reads as: "Powered by FloorPoll". */}
      <Logo /> <span className="vendor-mark-word">FloorPoll</span>
    </p>
  );
}
